import { api } from 'app/config/apiConfig';
import { AcceptContractItemPriceRaiseDto, ContractItemPriceRaise } from '../model/types';

export const acceptContractItemPriceRaiseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    acceptContractItemPriceRaise: builder.mutation<ContractItemPriceRaise, AcceptContractItemPriceRaiseDto & { contractId: string }>({
      query: ({ contractId, ...body }) => ({
        url: `/contracts/${contractId}/price-raise/accept`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Contracts', 'Contract item price raises'],
    }),
  }),
});

export const { useAcceptContractItemPriceRaiseMutation } = acceptContractItemPriceRaiseApi;
